
import { useEffect, useState, useRef } from 'react';

export default function WhatFoundersGet() {
  const [animated, setAnimated] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimated(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const features = [
    { name: 'Price', founder: '$25/mo', preLaunch: '$79/mo', standard: '$149/mo' },
    { name: 'Rate locked forever', founder: true, preLaunch: false, standard: false },
    { name: 'Early feature access', founder: true, preLaunch: true, standard: false },
    { name: 'Priority support', founder: true, preLaunch: false, standard: false },
    { name: 'Founder badge', founder: true, preLaunch: false, standard: false },
    { name: 'Input on roadmap', founder: true, preLaunch: false, standard: false },
  ];

  return (
    <section ref={sectionRef} className="relative py-16 sm:py-20 lg:py-32 bg-white">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <h2
          className={`font-harvey-serif text-[#09090b] text-[32px] sm:text-[42px] lg:text-[52px] font-normal tracking-tight text-center mb-8 sm:mb-12 lg:mb-16 transition-all duration-700 ${
            animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          What Founders Get
        </h2>

        <div className="overflow-x-auto">
          <div className="min-w-[600px]">
            <div className="grid grid-cols-4 gap-3 sm:gap-4 mb-3 sm:mb-4">
              <div className="font-harvey-sans text-[#71717a] text-xs sm:text-sm lg:text-base font-medium tracking-wide px-3 sm:px-4 py-2 sm:py-3">Feature</div>
              <div className="font-harvey-sans text-[#d4af37] text-xs sm:text-sm lg:text-base font-medium tracking-wide px-3 sm:px-4 py-2 sm:py-3 text-center">Founder</div>
              <div className="font-harvey-sans text-[#8B4513] text-xs sm:text-sm lg:text-base font-medium tracking-wide px-3 sm:px-4 py-2 sm:py-3 text-center">Pre-Launch</div>
              <div className="font-harvey-sans text-[#09090b] text-xs sm:text-sm lg:text-base font-medium tracking-wide px-3 sm:px-4 py-2 sm:py-3 text-center">Standard</div>
            </div>

            {features.map((feature, index) => (
              <div
                key={index}
                className={`grid grid-cols-4 gap-3 sm:gap-4 mb-3 sm:mb-4 bg-[#f5f0e8] border border-[#e8dcc8] rounded-xl transition-all duration-700 ${
                  animated ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
                }`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="font-harvey-sans text-[#09090b] px-3 sm:px-4 py-3 sm:py-4 text-xs sm:text-sm lg:text-base font-normal tracking-wide">{feature.name}</div>
                <div className="px-3 sm:px-4 py-3 sm:py-4 text-center">
                  {typeof feature.founder === 'boolean' ? (
                    <span className={`text-base sm:text-lg ${feature.founder ? 'text-[#d4af37]' : 'text-[#d4d4d8]'}`}>
                      {feature.founder ? '✓' : '✗'}
                    </span>
                  ) : (
                    <span className="font-harvey-sans text-[#d4af37] text-xs sm:text-sm lg:text-base font-medium tracking-wide">{feature.founder}</span>
                  )}
                </div>
                <div className="px-3 sm:px-4 py-3 sm:py-4 text-center">
                  {typeof feature.preLaunch === 'boolean' ? (
                    <span className={`text-base sm:text-lg ${feature.preLaunch ? 'text-[#8B4513]' : 'text-[#d4d4d8]'}`}>
                      {feature.preLaunch ? '✓' : '✗'}
                    </span>
                  ) : (
                    <span className="font-harvey-sans text-[#8B4513] text-xs sm:text-sm lg:text-base font-medium tracking-wide">{feature.preLaunch}</span>
                  )}
                </div>
                <div className="px-3 sm:px-4 py-3 sm:py-4 text-center">
                  {typeof feature.standard === 'boolean' ? (
                    <span className={`text-base sm:text-lg ${feature.standard ? 'text-[#09090b]' : 'text-[#d4d4d8]'}`}>
                      {feature.standard ? '✓' : '✗'}
                    </span>
                  ) : (
                    <span className="font-harvey-sans text-[#09090b] text-xs sm:text-sm lg:text-base font-medium tracking-wide">{feature.standard}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
